(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    /* O Horizon substitui apenas [ref="priceContainer"] quando se muda de variante.
     Atualizamos a pill com o HTML da mesma resposta para manter a percentagem certa. */
  document.addEventListener('shopify:product:select', (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise || typeof event.promise.then !== 'function') return;

    const section = event.target.closest('.shopify-section, dialog');
    if (!section) return;

    event.promise.then(({ detail }) => {
      if (!detail?.html) return;
      const html = detail.html;

      for (const priceBlock of section.querySelectorAll('product-price.mildhavn-product-price')) {
        const blockId = priceBlock.dataset.blockId;
        if (!blockId) continue;

        const updatedBlock = html.querySelector(`product-price[data-block-id="${CSS.escape(blockId)}"]`);
        if (!updatedBlock) continue;

        if (!detail.newProduct && detail.productId && String(detail.productId) !== priceBlock.dataset.productId) {
          continue;
        }

        const currentPill = priceBlock.querySelector('[data-mildhavn-discount-pill]');
        const updatedPill = updatedBlock.querySelector('[data-mildhavn-discount-pill]');

        if (currentPill && updatedPill) {
          currentPill.replaceWith(updatedPill.cloneNode(true));
        } else if (currentPill && !updatedPill) {
          currentPill.remove();
        } else if (!currentPill && updatedPill) {
          priceBlock.querySelector('.mildhavn-price-row')?.append(updatedPill.cloneNode(true));
        }
      }
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[MILDHAVN] Erro ao atualizar desconto:', error);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
